function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*------------------------------------------------------------------
Form Validation Class
------------------------------------------------------------------*/
var FormValidation = /*#__PURE__*/function (_Classy) {
  _inherits(FormValidation, _Classy);
  var _super = _createSuper(FormValidation);
  function FormValidation(formElement) {
    var _this;
    _classCallCheck(this, FormValidation);
    // Grab the events
    _this = _super.call(this);
    // The form element
    _this.form = formElement;
    // The form inputs
    _this.inputs = [];
    // The validity of the form
    _this.valid = false;
    // A list of fields that are not valid
    _this.invalid = [];

    // Various tests for inputs
    _this.tests = {
      emails: /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i
    };

    // Initialise the immediate inputs
    _this.update();
    return _this;
  }
  _createClass(FormValidation, [{
    key: "submit",
    value: function submit() {
      this.callback('submit');
    }
  }, {
    key: "update",
    value: function update() {
      var _this2 = this;
      // Empty the inputs array
      this.inputs = [];
      // Loop the form elements and push the inputs to the inputs array
      for (var i = 0; i < this.form.elements.length; i++) {
        // Save as input
        var input = this.form.elements[i];

        // Create an element to display the error in
        var error = document.createElement('p');
        // Add a class for styling the error
        error.className = 'form-error';
        this.inputs.push({
          element: input,
          error: error,
          name: input.name.replace(/([A-Z]+)*([A-Z][a-z])/g, "$1 $2"),
          label: input.parentNode.querySelector('label') || false
        });
      }
      ;
      this.inputs.forEach(function (input) {
        // If the form error has already been created then remove it from the DOM
        if (input.element.previousElementSibling && input.element.previousElementSibling.className == 'form-error') {
          input.element.parentNode.removeChild(input.element.previousElementSibling);
        }

        // Add the new error element to the DOM
        input.element.parentNode.appendChild(input.error);

        // If we blur() an input then check it is valid
        input.element.addEventListener('blur', function () {
          return _this2.check(input);
        });

        // If we change the value of an input then check it is valid
        input.element.addEventListener('change', function () {
          return _this2.check(input);
        });

        // If we focus() an input then check it is valid
        input.element.addEventListener('focus', function () {
          return _this2.ignore(input);
        });
      });

      // Call the update event
      this.callback('update');
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this3 = this;
      // Set the validation to true
      this.valid = true;
      // Reset the invalid array
      this.invalid = [];

      // Loop all the input elements
      this.inputs.forEach(function (input) {
        return _this3.check(input);
      });

      // Call the validate event
      this.callback('validate', this.valid);
    }
  }, {
    key: "check",
    value: function check(input) {
      // If the input is invalid
      if (input.element.willValidate && input.element.checkValidity() == false) {
        // Add a validation error class
        input.element.parentNode.classList.add('validation-error');
        // The form as a whole is no longer valid
        this.valid = false;
        // Show an error for this input
        this.error(input);
        // Add the input to the invalid array
        this.invalid.push(input);
      } else {
        // Otherwise ignore it because it is valid
        this.ignore(input);
      }
    }
  }, {
    key: "ignore",
    value: function ignore() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // If this input is an element
      if (input && input.element.nodeType) {
        input.element.parentNode.classList.remove('validation-error');
      }
    }
  }, {
    key: "error",
    value: function error() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // If we passed in an input element
      if (input && input.element.nodeType) {
        // Empty the error message
        input.error.innerHTML = '';

        // Add a name to the error so we know what field we are talking about.

        // First try use the label text
        if (input.label) {
          input.error.innerHTML += input.label.innerText;
        } else {
          // Otherwise use the name attribute
          input.error.innerHTML += input.name;
        }
        switch (input.element.type) {
          case 'email':
            // Tell us it is no the correct format
            if (!this.tests.emails.test(input.element.value) && input.element.value) {
              input.error.innerHTML += ' is not a valid email address.';
              break;
            }
          default:
            // Tell us it is required
            input.error.innerHTML += ' is required.';
            break;
        }
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      // Reset the form
      this.form.reset();
      // Reset the form inputs
      this.inputs.forEach(function (input) {
        input.element.parentNode.classList.remove('validation-error');
      });
    }
  }]);
  return FormValidation;
}(Classy);
/*------------------------------------------------------------------
ReCaptcha Validation
------------------------------------------------------------------*/
var ReCaptchaValidation = /*#__PURE__*/function (_Classy2) {
  _inherits(ReCaptchaValidation, _Classy2);
  var _super2 = _createSuper(ReCaptchaValidation);
  function ReCaptchaValidation(field) {
    var _this4;
    _classCallCheck(this, ReCaptchaValidation);
    _this4 = _super2.call(this);
    // The recaptcha field
    _this4.field = field || false;
    // The validitiy of the recaptcha
    _this4.valid = false;
    return _this4;
  }
  _createClass(ReCaptchaValidation, [{
    key: "validate",
    value: function validate() {
      if (this.field && window.grecaptcha) {
        // Check the recaptcha response
        if (window.grecaptcha.getResponse() == '') {
          // The recaptcha is invalid
          this.valid = false;
          // Continuously check the validity from now on
          this.protect();
          // Call the validate event
          this.callback('validate', this.valid);
        } else {
          // The recaptcha is valid
          this.valid = true;
          // Call the validate event
          this.callback('validate', this.valid);
        }
      } else this.valid = true;
      return this.valid;
    }
  }, {
    key: "protect",
    value: function protect() {
      var _this5 = this;
      setTimeout(function () {
        return _this5.validate();
      }, 1000);
    }
  }]);
  return ReCaptchaValidation;
}(Classy);
export { FormValidation, ReCaptchaValidation };